import { Box, Container, Heading, SimpleGrid, Image, Text, Spacer, Flex, Button } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "scenes/layouts";
import LoadingScreen from "components/loading-screen";
import ProgramService from "services/programs/program-service";
import { FiUsers } from "react-icons/fi";

const ListProgramScene = (): ReactElement => {
    const navigate = useNavigate();
    const [programs, setPrograms] = useState<any>([]);
    const [isLoading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        setLoading(true);
        ProgramService.GetAllProgram().then((response: any) => {
            setPrograms(response.result);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} mt={2} mb={5}>
                <Box>
                    <Heading fontSize={'3xl'} fontWeight={"extrabold"}>Programs</Heading>
                </Box>
                <Flex mt={3}>
                    <Spacer />
                    <Button onClick={() => navigate('/programs/new')}>Buat Program Baru</Button>
                </Flex>
                <Box mt={6}>
                    <SimpleGrid columns={[1, 2, 3]} gap={6} mt={10}>
                        {
                            programs.map((program: any) => {
                                return (
                                    <Box flex={3} rounded={'lg'} boxShadow={'lg'} border={'1px'} borderColor={"gray.400"} cursor={'pointer'}
                                        onClick={() => navigate(`/programs/${program.id}`)}
                                    >
                                        <Box
                                            w={'full'}
                                            //bg={useColorModeValue('white', 'gray.900')}
                                            bg={'white'}
                                            boxShadow={'md'}
                                            rounded={'md'}
                                            overflow={'hidden'}>
                                            <Box
                                                pos={'relative'}>
                                                <Image
                                                    src={program.posterUrl}
                                                />
                                            </Box>
                                            <Flex px={5} py={3}>
                                                <Box>
                                                    <Heading fontSize={'md'}>
                                                        {program.name}
                                                    </Heading>
                                                    <Text fontSize={'sm'} mt={0}>
                                                        {program.author.name}
                                                    </Text>
                                                    <Text fontSize={'sm'} mt={0}>
                                                        Status: {program.statusString}
                                                    </Text>
                                                </Box>
                                                <Spacer />

                                                <Box >
                                                    <Flex alignItems={'center'} fontSize={'sm'}>
                                                        <FiUsers />
                                                        <Text ml={2}>
                                                            {program.enrolled}
                                                        </Text>
                                                    </Flex>
                                                </Box>
                                            </Flex>
                                        </Box>
                                    </Box>
                                )
                            })
                        }

                    </SimpleGrid>
                </Box>
            </Container>
        </Layout>
    );
};

export default ListProgramScene;